module.exports = __webpack_public_path__ + "media/images/ui__textCross-fe8f05ae5a9c73b12fe1c358f1724ff8.png";